<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 2C12.5523 2 13 2.44772 13 3L13.001 4.06201C16.6193 4.51365 19.487 7.3817 19.9381 11.0002L21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13L19.938 13.0008C19.4865 16.6188 16.619 19.4864 13.001 19.938L13 21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21L11 19.9381C7.38161 19.4869 4.51362 16.6192 4.06201 13.0009L3 13C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11L4.06188 11.0001C4.51309 7.38132 7.38128 4.51312 11 4.06189L11 3C11 2.44772 11.4477 2 12 2ZM12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6Z"
    fill="currentColor"
  />
</svg>
